/**
 * StyledChannelViewContainer component.
 */
import styled from 'styled-components';

/**
 * Styled channel view container.
 */
const StyledChannelViewContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export default StyledChannelViewContainer;
